import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft, CalendarCheck, GraduationCap, DollarSign } from 'lucide-react';
import { Button } from '../../components/ui/Button';
export function WatchMeGrow() {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  return <div className="w-full pt-24 pb-24 bg-engage-black min-h-screen" data-id="element-495" data-mp="38gunsdvubenc">
      <div className="max-w-6xl mx-auto px-4" data-id="element-496" data-mp="38j730ja7rawp">
        {/* Back Link */}
        <Link to="/case-studies" className="inline-flex items-center text-engage-gray4 hover:text-engage-yellow transition-colors mb-12 font-medium" data-id="element-497" data-mp="2tr5c3oq4fs8t">
          <ArrowLeft className="w-4 h-4 mr-2" data-id="element-498" data-mp="2kt30kf8rhh7a" />
          Back to Case Studies
        </Link>

        {/* Hero */}
        <div className="mb-16 max-w-4xl" data-id="element-499" data-mp="2otmz9n8zgsvj">
          <div className="flex flex-wrap gap-3 mb-6" data-id="element-500" data-mp="2atvr4355e6pg">
            <span className="px-4 py-1.5 bg-engage-yellow/10 text-engage-yellow border border-engage-yellow/20 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-501" data-mp="2audurku53n7e">
              Lead Generation
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-502" data-mp="1v97jcs033sda">
              Education Marketing
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-503" data-mp="2479pflyodb7f">
              Paid Ads
            </span>
            <span className="px-4 py-1.5 bg-engage-gray2 text-engage-gray5 rounded-full text-sm font-bold uppercase tracking-wider" data-id="element-504" data-mp="1bk6v76117mmz">
              Engage Machine
            </span>
          </div>
          <h1 className="text-5xl md:text-6xl lg:text-7xl font-black text-engage-white tracking-tight mb-4" data-id="element-505" data-mp="1l9ysw94fgvvo">
            Watch Me Grow Learning Center
          </h1>
          <h2 className="text-2xl md:text-3xl text-engage-gray4 font-medium leading-tight" data-id="element-506" data-mp="ssmh191nbgt3">
            Turning Demand Into Enrollments in Just 90 Days
          </h2>
        </div>

        {/* Key Results Stats */}
        <div className="mb-16" data-id="element-507" data-mp="2nwu8qdyzbo1m">
          <div className="grid grid-cols-1 md:grid-cols-3 gap-6" data-id="element-508" data-mp="2nvj308lz467v">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-509" data-mp="2sudk964almpv">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-510" data-mp="32kyrfhy17zke">
                <CalendarCheck className="w-24 h-24 text-engage-yellow" data-id="element-511" data-mp="24xgctqhow38h" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-512" data-mp="29w1abi5k48t8">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-513" data-mp="29y49arootca3">
                  <CalendarCheck className="w-6 h-6 text-engage-yellow" data-id="element-514" data-mp="2ix7ty03i5zqp" />
                </div>
                <div data-id="element-515" data-mp="3qbaxen9pvm8c">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-516" data-mp="3q9rhwyvvxf7m">
                    123
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-517" data-mp="1iojabjb5oc6s">
                    School Tours
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-518" data-mp="19vxry4bfs7ih">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-519" data-mp="14vjufg7gofyp">
                <GraduationCap className="w-24 h-24 text-engage-yellow" data-id="element-520" data-mp="uz6sjv1rivsv" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-521" data-mp="qxlisikiyxmw">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-522" data-mp="qzpn31mc5ynp">
                  <GraduationCap className="w-6 h-6 text-engage-yellow" data-id="element-523" data-mp="2lc5yegtzo2zf" />
                </div>
                <div data-id="element-524" data-mp="2gc03mrsfa0d4">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-525" data-mp="2gdl04myartdm">
                    67
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-526" data-mp="1czsykfmshcgj">
                    Student Enrollments
                  </div>
                </div>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 relative overflow-hidden group hover:border-engage-yellow/50 transition-colors" data-id="element-527" data-mp="18zsfghoqwd35">
              <div className="absolute top-0 right-0 p-6 opacity-5 group-hover:opacity-10 transition-opacity" data-id="element-528" data-mp="u91nn9n5le01">
                <DollarSign className="w-24 h-24 text-engage-yellow" data-id="element-529" data-mp="lag69htf450u" />
              </div>
              <div className="relative z-10 flex flex-col h-full justify-between" data-id="element-530" data-mp="l8mvprfop0nk">
                <div className="w-12 h-12 bg-engage-black border border-engage-gray2 rounded-xl flex items-center justify-center mb-6" data-id="element-531" data-mp="pcb8coj6amfo">
                  <DollarSign className="w-6 h-6 text-engage-yellow" data-id="element-532" data-mp="gb3j0vymwvxq" />
                </div>
                <div data-id="element-533" data-mp="3suz4px7rawgg">
                  <div className="text-4xl md:text-5xl font-black text-engage-white mb-2 tracking-tight" data-id="element-534" data-mp="3su5yqygmgazd">
                    27x
                  </div>
                  <div className="text-engage-gray4 font-medium uppercase tracking-wider text-sm" data-id="element-535" data-mp="3nxyynmawptpc">
                    Annual ROAS
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Content Sections */}
        <div className="space-y-10" data-id="element-536" data-mp="fmuqmm65qba0">
          {/* The Challenge */}
          <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-12" data-id="element-537" data-mp="aq4bc126fjpn">
            <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-538" data-mp="peide9rrr455">
              The Challenge
            </h3>
            <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-539" data-mp="kfnwjddd3pno" />
            <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-540" data-mp="ye5ib5jpis2y">
              Despite having a strong academic offering, the school operated
              with 0 predictable enrollment system, relying heavily on word of
              mouth and inconsistent marketing, which led to underfilled
              capacity and missed revenue opportunities. Even with clear demand
              in the market, there was no structured funnel to capture or
              convert it, resulting in lost enrollments and no reliable way to
              scale growth.
            </p>
          </div>

          {/* Our Approach & The Result */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-6" data-id="element-541" data-mp="1k941n19wyjti">
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-542" data-mp="1p4t3xcdbieti">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-543" data-mp="1u5z2vrxkmybh" />
              <div className="relative z-10" data-id="element-544" data-mp="3vx3skify1ot6">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-545" data-mp="3vyes262cwaeh">
                  Our Approach
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-546" data-mp="2i0aj4uvtxthe" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-547" data-mp="2i2dja7qp52zu">
                  We built a streamlined enrollment system centered around a
                  single conversion goal—booking school tours—which generated
                  123 qualified tour bookings in 90 days. By refining messaging
                  to match parent decision drivers and launching targeted
                  campaigns to attract high-intent local traffic, we optimized
                  every step of the funnel to efficiently move families from
                  initial interest to confirmed enrollment.
                </p>
              </div>
            </div>
            <div className="bg-engage-gray1 border border-engage-gray2 rounded-2xl p-8 md:p-10 relative overflow-hidden" data-id="element-548" data-mp="2mz3uohrk3aex">
              <div className="absolute top-0 right-0 w-40 h-40 bg-[radial-gradient(circle_at_top_right,rgba(252,198,13,0.12)_0%,transparent_70%)]" data-id="element-549" data-mp="1ghgtij344ota" />
              <div className="relative z-10" data-id="element-550" data-mp="3bmgcimn0g7ma">
                <h3 className="text-2xl md:text-3xl font-bold text-engage-white mb-3" data-id="element-551" data-mp="3boswf5cbws1z">
                  The Result
                </h3>
                <div className="w-16 h-1 bg-engage-yellow rounded-full mb-6" data-id="element-552" data-mp="31p1yetok7ux5" />
                <p className="text-engage-gray4 text-base md:text-lg leading-relaxed" data-id="element-553" data-mp="36nn25330swqc">
                  In just 90 days, the school shifted from unpredictable growth
                  to a controlled system that generated 123 tours, converted
                  into 67 new student enrollments, and delivered a 27x annual
                  ROAS, turning what was once inconsistent into a repeatable,
                  scalable enrollment engine that drives results on demand.
                </p>
              </div>
            </div>
          </div>

          {/* Testimonial */}
          <div className="bg-engage-gray1 border border-engage-gray2 p-10 md:p-16 lg:p-20 rounded-2xl relative overflow-hidden text-center" data-id="element-554" data-mp="h4l10ml41g82">
            <div className="flex justify-center mb-8" data-id="element-555" data-mp="26n9p3ocwu03k">
              <svg width="40" height="40" viewBox="0 0 24 24" fill="currentColor" xmlns="http://www.w3.org/2000/svg" className="text-engage-yellow" data-id="element-556" data-mp="26lq97yv61r2b">
                <path d="M14.017 21L16.411 14.182C16.411 14.182 15.045 14.182 15.045 10.773C15.045 7.36364 18.006 5 21 5C23.994 5 24 7.36364 24 7.36364C24 7.36364 22.634 7.36364 22.634 10.773C22.634 14.182 19.909 21 19.909 21H14.017ZM3.017 21L5.411 14.182C5.411 14.182 4.045 14.182 4.045 10.773C4.045 7.36364 7.006 5 10 5C12.994 5 13 7.36364 13 7.36364C13 7.36364 11.634 7.36364 11.634 10.773C11.634 14.182 8.909 21 8.909 21H3.017Z" data-id="element-557" data-mp="2bfks502y620c" />
              </svg>
            </div>
            <blockquote className="text-xl sm:text-2xl md:text-3xl lg:text-4xl font-medium italic text-engage-white mb-10 md:mb-12 leading-relaxed relative z-10 max-w-4xl mx-auto" data-id="element-558" data-mp="384iq0r5zug1q">
              We didn't just generate leads—we built a system that consistently
              turns demand into enrollments.
            </blockquote>
            <div className="flex flex-col items-center relative z-10" data-id="element-559" data-mp="w2h8elps1nen">
              <img src="https://cdn.magicpatterns.com/uploads/j9vzgDyKVGVYwakdCtvgED/Watch_Me_Grow-CS.png" alt="Watch Me Grow" className="w-16 h-16 md:w-20 md:h-20 rounded-full mb-4 border-2 border-engage-gray2 object-cover" data-id="element-560" data-mp="r9xu1mj9mo8s" />
              <div className="font-bold text-engage-white text-lg" data-id="element-561" data-mp="cdgl11yjtlpe">
                Watch Me Grow Team
              </div>
              <div className="text-engage-yellow font-medium text-sm uppercase tracking-wider" data-id="element-562" data-mp="8atquueenop1">
                Watch Me Grow Learning Center
              </div>
            </div>
          </div>
        </div>

        {/* CTA */}
        <div className="mt-20 text-center bg-engage-gray1 border border-engage-gray2 rounded-2xl p-12 md:p-20 relative overflow-hidden" data-id="element-563" data-mp="22p4fp2v02iut">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_center,rgba(252,198,13,0.08)_0%,transparent_100%)]" data-id="element-564" data-mp="25a2c4chwzqxf" />
          <div className="relative z-10 max-w-4xl mx-auto" data-id="element-565" data-mp="2a8doatvomdit">
            <h2 className="text-3xl md:text-5xl font-black mb-6 tracking-tight" data-id="element-566" data-mp="2a6su55da4wlh">
              Ready to Build Your Growth Engine?
            </h2>
            <p className="text-engage-gray4 text-xl mb-10" data-id="element-567" data-mp="2jxx5lv3qxzbk">
              Stop guessing with your marketing budget. Let's build a
              predictable system for your brand.
            </p>
            <Button to="/contact" variant="primary" className="text-lg px-12 py-5" data-id="element-568" data-mp="1r9hx7rf4ef97">
              Book a Call With Us
            </Button>
          </div>
        </div>
      </div>
    </div>;
}